import { ResponsiveStateEnteredEventArgs as ResponsiveStateEnteredEventArgs_internal } from "./ResponsiveStateEnteredEventArgs";
/**
 * Information about the entered action.
*/
var IgrResponsiveStateEnteredEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrResponsiveStateEnteredEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrResponsiveStateEnteredEventArgs.prototype.createImplementation = function () {
        return new ResponsiveStateEnteredEventArgs_internal();
    };
    Object.defineProperty(IgrResponsiveStateEnteredEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrResponsiveStateEnteredEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrResponsiveStateEnteredEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    return IgrResponsiveStateEnteredEventArgs;
}());
export { IgrResponsiveStateEnteredEventArgs };
//# sourceMappingURL=igr-responsive-state-entered-event-args.js.map
